import React from 'react';

export const FormSubmissionsContext = React.createContext({});

export const FormSubmissionsProvider = FormSubmissionsContext.Provider;
